import { errorMsg } from '../constants/messages';

const CategoryFormData = [
    {
        title: 'Category Sections Details',
        name: 'name',
        label: 'Category Name',
        fieldType: {
            name: 'text',
        },
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Category Name', allowAddRecordClick: true },
        isTableHeader: true,
        isAccordian: true,
    },
    {
        name: 'type',
        label: 'Type',
        fieldType: {
            name: 'text',
        },
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Type', allowAddRecordClick: true },
        isTableHeader: true,
        isAccordian: true,
    },
    {
        name: 'status',
        label: 'Status',
        fieldType: {
            name: 'select',
            options: [
                { name: 'Active', value: 'Active' },
                { name: 'Inactive', value: 'Inactive' },
            ],
        },
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Status', allowAddRecordClick: true },
        isTableHeader: false,
        isAccordian: true,
    },
    {
        name: 'images',
        label: 'Images',
        fieldType: {
            name: 'multiImageUpload',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Image', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: true,
    },
    {
        name: 'desktopPngUrl',
        label: 'Desktop Image(Png)',
        fieldType: {
            name: 'documitraFile',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Image', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: true,
        isAccordian: false,
    },
    {
        name: 'isSpatialRenderProductDropdown',
        label: 'Spatial Render In Dropdown',
        fieldType: {
            name: 'select',
            options: [
                { name: 'True', value: true },
                { name: 'False', value: false },
            ],
        },
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Spatial Render Product Dropdown' },
        isTableHeader: false,
        isAccordian: true,
        default: false,
    },
    // 4 inputs for first image
    {
        name: 'desktopSpatialPngUrl1',
        label: '1st Spatial Desktop Image(Png)',
        dependentOnSpatialRender: true,
        fieldType: {
            name: 'documitraFile',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Image', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: true,
        isAccordian: false,
    },
    {
        name: 'desktopSpatialWebPUrl1',
        label: '1st Spatial Desktop Image(WebP)',
        dependentOnSpatialRender: true,
        fieldType: {
            name: 'documitraFile',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Desktop Image(WebP)', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: false,
    },
    {
        name: 'mobileSpatialPngUrl1',
        label: '1st Spatial Mobile Image(Png)',
        dependentOnSpatialRender: true,
        fieldType: {
            name: 'documitraFile',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Mobile Image(Png)', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: false,
    },
    {
        name: 'mobileSpatialWebPUrl1',
        label: '1st Spatial Mobile Image(WebP)',
        dependentOnSpatialRender: true,
        fieldType: {
            name: 'documitraFile',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Mobile Image(WebP)', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: false,
    },
    // 4 inputs for second image
    {
        name: 'desktopSpatialPngUrl2',
        label: '2nd Spatial Desktop Image(Png)',
        dependentOnSpatialRender: true,
        fieldType: {
            name: 'documitraFile',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Image', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: true,
        isAccordian: false,
    },
    {
        name: 'desktopSpatialWebPUrl2',
        label: '2nd Spatial Desktop Image(WebP)',
        dependentOnSpatialRender: true,
        fieldType: {
            name: 'documitraFile',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Desktop Image(WebP)', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: false,
    },
    {
        name: 'mobileSpatialPngUrl2',
        label: '2nd Spatial Mobile Image(Png)',
        dependentOnSpatialRender: true,
        fieldType: {
            name: 'documitraFile',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Mobile Image(Png)', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: false,
    },
    {
        name: 'mobileSpatialWebPUrl2',
        label: '2nd Spatial Mobile Image(WebP)',
        dependentOnSpatialRender: true,
        fieldType: {
            name: 'documitraFile',
            maxCount: '1',
            allowImageCropping: true,
        },
        placeholder: 'Click here to select',
        required: true,
        errorMsg: errorMsg,
        tableMeta: { title: 'Mobile Image(WebP)', enableSort: false, allowAddRecordClick: false, columnType: 'image' },
        isTableHeader: false,
        isAccordian: false,
    },
];

export { CategoryFormData };
